import {GlobalVariables} from "../GlobalVariables";

export default class BlockSectorsCollectivities {
    constructor() {
        this.blocks = document.querySelectorAll(".block-sectors-collectivities");

        if (this.blocks && this.blocks.length > 0) {
            this.listMapHovers();
            this.popins();

            document.addEventListener("escape.pressed", () => {
                this.closeAllPopins();
            });
        }
    }

    popins() {
        this.blocks.forEach(block => {
            const btns = block.querySelectorAll(".nav-collectivities a");
            const popins = block.querySelectorAll(".sector-popin-container");

            btns.forEach(btn => {
                const target = btn.dataset.target;
                btn.addEventListener("click", (e) => {
                    const popin = block.querySelector("#popin-" + target);
                    e.preventDefault();
                    if (popin) {
                        popins.forEach(item => {
                            item.classList.remove("is-visible");
                        });
                        this.openPopin(popin);
                    }
                });
            });

            popins.forEach(popin => {
                // initialisation du secteur actif de la carte
                const map = popin.querySelector(".map-sector");
                const sectorID = map.id;
                const mapSectors = map.querySelectorAll(".sector");
                mapSectors.forEach(sector => {
                    if (sector.id === sectorID) {
                        sector.classList.add("is-active");
                    } else {
                        sector.classList.add("is-inactive");
                    }
                });

                const closeBtn = popin.querySelector(".close");
                closeBtn.addEventListener("click", (e) => {
                    e.preventDefault();
                    this.closePopin(popin);
                });

                popin.addEventListener("click", (e) => {
                    if (e.target.classList.contains("sector-popin-container")) {
                        this.closePopin(popin);
                    }
                });
            });
        });
    }

    openPopin(popin) {
        popin.classList.add("is-visible");
        GlobalVariables.lenis?.stop();
    }

    closePopin(popin) {
        popin.classList.remove("is-visible");
        GlobalVariables.lenis?.start();
    }

    closeAllPopins() {
        document.querySelectorAll(".sector-popin-container").forEach(popin => {
            popin.classList.remove("is-visible");
        });
        GlobalVariables.lenis?.start();
    }

    listMapHovers() {
        this.blocks.forEach(block => {
            const btns = block.querySelectorAll(".nav-collectivities a");
            const mapSectors = block.querySelectorAll(".map-sectors .sector");

            btns.forEach(btn => {
                btn.addEventListener("mouseenter", (e) => {
                    const sectorID = btn.dataset.target;

                    mapSectors.forEach(sector => {
                        if (sector.id === sectorID) {
                            sector.classList.add("is-active");
                        } else {
                            sector.classList.add("is-inactive");
                        }
                    });
                });

                btn.addEventListener("mouseleave", (e) => {
                    mapSectors.forEach(sector => {
                        sector.classList.remove("is-active");
                        sector.classList.remove("is-inactive");
                    });
                });
            });

            mapSectors.forEach(mapSector => {
                const sectorID = mapSector.id;
                mapSector.addEventListener("click", (e) => {
                   const btnTarget = block.querySelector(".nav-collectivities a[data-target='"+sectorID+"']");

                    if (btnTarget) {
                        btnTarget.click();
                    }
                });

                mapSector.addEventListener("mouseenter", (e) => {
                    const sectorID = mapSector.id;

                    mapSectors.forEach(sector => {
                        if (sector.id === sectorID) {
                            sector.classList.add("is-active");
                        } else {
                            sector.classList.add("is-inactive");
                        }
                    });

                    btns.forEach(btn => {
                        if (btn.dataset.target === sectorID) {
                            btn.classList.add("is-hover");
                        } else {
                            btn.classList.remove("is-hover");
                        }
                    });
                });

                mapSector.addEventListener("mouseleave", (e) => {
                    mapSectors.forEach(item => {
                        item.classList.remove("is-active");
                        item.classList.remove("is-inactive");
                    });

                    btns.forEach(btn => {
                        btn.classList.remove("is-hover");
                    });
                });
            });
        });
    }
}